module.exports = __webpack_public_path__ + "img/logo.cd581d12.png";